import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { getProtocol } from 'utils/location'

export function useTextClipboard() {
  return (text: string) => {
    if (getProtocol() !== 'https:') {
      showErrorMessageToast(
        'You need to be on a secure connection to copy the API key. That is enforced by the browser itself.',
      )
    } else {
      navigator.clipboard.writeText(text)
    }
  }
}
